module.exports = __webpack_public_path__ + "static/img/TYLAH-WILLIAMS.8c08ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TYLAH-WILLIAMS.jpg
// module id = mUSF
// module chunks = 0